import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton/FlatButton';
import translate from 'components/hoc/translate';
import languagesHelper from 'helpers/languages';

const styles = {
    content: {
        margin: '20px 0',
    },
};

class TranslateDialog extends React.Component {
    state = {
        showDialog: true,
    }

    handleCloseDialog = () => {
        this.setState({
            showDialog: false,
        });
    }

    render() {
        const {
            handleCancel,
            handleSubmit,
            sourceLanguage,
            targetLanguage,
            translate,
        } = this.props;

        const { showDialog } = this.state;

        const actions = [
            <FlatButton
                keyboardFocused={ true }
                key='cancel-translate'
                label={ translate('actions.cancel') }
                onTouchTap={ () => {
                    handleCancel();

                    this.handleCloseDialog();
                } }
                primary={ true }
            />,
            <FlatButton
                keyboardFocused={ false }
                key='ok-translate'
                label={ translate('actions.ok') }
                onTouchTap={ () => {
                    const { targetLanguage } = this.props;

                    handleSubmit(targetLanguage);

                    this.handleCloseDialog();
                } }
                primary={ true }
            />,
        ];

        return (
            <Dialog
                title={ translate('forms.localisation.origin.title', {
                    source: languagesHelper.getLabel(sourceLanguage),
                }) }
                actions={ actions }
                modal={ false }
                open={ showDialog }
                overlayStyle={ {
                    backgroundColor: 'rgba(237, 236, 236, 0.6)',
                } }
                autoScrollBodyContent={ true }
                onRequestClose={ () => {
                    this.handleCloseDialog();
                } }
            >
                <div style={ styles.content }>
                    { translate('forms.localisation.origin.description', {
                        locale: languagesHelper.getLabel(sourceLanguage),
                        target: languagesHelper.getLabel(targetLanguage),
                    }) }
                </div>
            </Dialog>
        );
    }
}

TranslateDialog.propTypes = {
    handleCancel: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    sourceLanguage: PropTypes.string.isRequired,
    targetLanguage: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(TranslateDialog);



// WEBPACK FOOTER //
// ./src/components/form/localisation/dialog/TranslateDialog.js